import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { RPESubActividad } from './rpe-sub-actividades.model';

// ADD
export const entityRPESubActividadesAddRequest = createAction(
  '[ENTITYRPESUBACTIVIDADES] Add Request',
  props<{ item: RPESubActividad[] }>()
);

export const entityRPESubActividadesAddFailure = createAction(
  '[ENTITYRPESUBACTIVIDADES] Add Failure',
  props<{ error: Error }>()
);

export const entityRPESubActividadesAddSuccess = createAction(
  '[ENTITYRPESUBACTIVIDADES] Add Success',
  props<{ item: RPESubActividad[] }>()
);
